import React from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router';
import { StoreSelectors, useStoreSelector } from 'app/store';

export const DownloadReportPage = () => {
  const params = useParams();
  const navigate = useNavigate();

  const ownerId = useStoreSelector<string>(state => StoreSelectors.AppSelector.selectOwnerId(state.AppReducer));

  const downloadReport = React.useCallback(
    async (encodedFilename: string) => {
      return axios.get(`/owners/${ownerId}/report/${encodedFilename}`, {});
    },
    [ownerId],
  );

  const executeDownload = React.useCallback(async () => {
    const response = await downloadReport(params?.encodedFilename ?? '');

    if (response.status === 200) {
      const element = document.createElement('a');
      element.href = response.data;

      document.body.appendChild(element);
      element.click();
    }
  }, [downloadReport, params?.encodedFilename]);

  React.useEffect(() => {
    executeDownload().then(() => {
      navigate('/');
    });
    // eslint-disable-next-line
  }, []);

  return null;
};
